export const altGaming = {
  jiliGaming: {
    FortuneGems: {
      code: "",
      casino: "JiLi Gaming",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Gems",
      name: "Fortune Gems",
      providerName: "JiLi Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunegems.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-gems",
    },
    ColorPrediction: {
      code: "",
      casino: "JiLi Gaming",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Color Prediction",
      name: "Color Prediction",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ColorPrediction.webp",
      redirectUrl: "/casino/aggapjiligaming-color-prediction",
    },
    PirateQueen: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pirate Queen",
      name: "Pirate Queen",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Piratequeen.jpg",
      redirectUrl: "/casino/aggapjiligaming-pirate-queen",
    },
    WildRacer: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Racer",
      name: "Wild Racer",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Wildracer.jpg",
      redirectUrl: "/casino/aggapjiligaming-wild-racer",
    },
    NekoFortune: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Neko Fortune",
      name: "Neko Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/nekofortune.jpg",
      redirectUrl: "/casino/aggapjiligaming-neko-fortune",
    },
    Samba: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Samba",
      name: "Samba",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/samba.jpg",
      redirectUrl: "/casino/aggapjiligaming-samba",
    },
    WorldCup: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "World Cup",
      name: "World Cup",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/worldcup.jpg",
      redirectUrl: "/casino/aggapjiligaming-world-cup",
    },
    BonusHunter: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bonus Hunter",
      name: "Bonus Hunter",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bonushunter.jpg",
      redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
    },
    JILICAISHEN: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "JILI CAISHEN",
      name: "JILI CAISHEN",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jilicaishen.jpg",
      redirectUrl: "/casino/aggapjiligaming-jili-caishen",
    },
    MayanEmpire: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mayan Empire",
      name: "Mayan Empire",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Mayanempire.webp",
      redirectUrl: "/casino/aggapjiligaming-mayan-empire",
    },
    BoneFortune: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bone Fortune",
      name: "Bone Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bonefortune.webp",
      redirectUrl: "/casino/aggapjiligaming-bone-fortune",
    },
    GoldRush: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gold Rush",
      name: "Gold Rush",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Goldrush.webp",
      redirectUrl: "/casino/aggapjiligaming-gold-rush",
    },
    HappyTaxi: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Happy Taxi",
      name: "Happy Taxi",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/happytaxi.jpg",
      redirectUrl: "/casino/aggapjiligaming-happy-taxi",
    },
    ThorX: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Thor X",
      name: "Thor X",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ThorX.jpg",
      redirectUrl: "/casino/aggapjiligaming-thor-x",
    },
    BookofGold: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Book of Gold",
      name: "Book of Gold",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bookofgold.jpg",
      redirectUrl: "/casino/aggapjiligaming-book-of-gold",
    },
    Medusa: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Medusa",
      name: "Medusa",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/medusa.jpg",
      redirectUrl: "/casino/aggapjiligaming-medusa",
    },
    GoGoalBingo: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Go Goal Bingo",
      name: "Go Goal Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/gogoalbingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-go-goal-bingo",
    },
    ColorGame: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Color Game",
      name: "Color Game",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ColorGame.webp",
      redirectUrl: "/casino/aggapjiligaming-color-game",
    },
    JackpotBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jackpot Bingo",
      name: "Jackpot Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jackpotbingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-jackpot-bingo",
    },
    LuckyBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Bingo",
      name: "Lucky Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckybingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-lucky-bingo",
    },
    WinDrop: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Win Drop",
      name: "Win Drop",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/windrop.jpg",
      redirectUrl: "/casino/aggapjiligaming-win-drop",
    },
    FortuneBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Bingo",
      name: "Fortune Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunebingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-bingo",
    },
    Baccarat: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/baccarat.jpg",
      redirectUrl: "/casino/aggapjiligaming-baccarat",
    },
    iRichBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "iRich Bingo",
      name: "iRich Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/iRichBingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-irich-bingo",
    },

    GoldenJoker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Joker",
      name: "Golden Joker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/goldenjoker.jpg",
      redirectUrl: "/casino/aggapjiligaming-golden-joker",
    },
    MasterTiger: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Master Tiger",
      name: "Master Tiger",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mastertiger.jpg",
      redirectUrl: "/casino/aggapjiligaming-master-tiger",
    },
    WildAce: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Ace",
      name: "Wild Ace",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/WildAce.webp",
      redirectUrl: "/casino/aggapjiligaming-wild-ace",
    },
    Crazy777: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy 777",
      name: "Crazy 777",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Crazy777.jpg",
      redirectUrl: "/casino/aggapjiligaming-crazy777",
    },

    ultimatetexasholdem: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ultimate Texas Hold'em",
      name: "Ultimate Texas Hold'em",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_ultimate_texas_holdem.png",
      redirectUrl: "/casino/aggapjiligaming-ultimate-texas-holdem",
    },
    jili_keno_nonus_number: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Keno Bonus Number",
      name: "Keno Bonus Number",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_keno_nonus_number.png",
      redirectUrl: "/casino/aggapjiligaming-keno-bonus-number",
    },
    jili_crash_cricket: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Cricket",
      name: "Crash Cricket",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_crash_cricket.png",
      redirectUrl: "/casino/aggapjiligaming-crash-cricket",
    },
    jili_crash_goal: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Goal",
      name: "Crash Goal",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_crash_goal.png",
      redirectUrl: "/casino/aggapjiligaming-crash-goal",
    },
    jili_fortune_roulette: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Roulette",
      name: "Fortune Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_fortune_roulette.png",
      redirectUrl: "/casino/aggapjiligaming-fortune-roulette",
    },
    jili_cricket_roulettte: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Roulette",
      name: "Cricket Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_cricket_roulettte.png",
      redirectUrl: "/casino/aggapjiligaming-cricket-roulette",
    },
    jili_super_esabong: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super E-Sabong",
      name: "Super E-Sabong",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_super_esabong.png",
      redirectUrl: "/casino/aggapjiligaming-super-e-sabong",
    },
    jili_thai_hilo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Thai Hilo",
      name: "Thai Hilo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_thai_hilo.png",
      redirectUrl: "/casino/aggapjiligaming-thai-hilo",
    },
    jili_boxing_extravaganza: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Boxing Extravaganza",
      name: "Boxing Extravaganza",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_boxing_extravaganza.png",
      redirectUrl: "/casino/aggapjiligaming-boxing-extravaganza",
    },
    jili_jhandi_munda: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jhandi Munda",
      name: "Jhandi Munda",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_jhandi_munda.png",
      redirectUrl: "/casino/aggapjiligaming-jhandi-munda",
    },
    jili_super_ace_scratch: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Ace Scratch",
      name: "Super Ace Scratch",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_super_ace_scratch.png",
      redirectUrl: "/casino/aggapjiligaming-super-ace-scratch",
    },
    jili_fish_prawn_crab: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fish Prawn Crab",
      name: "Fish Prawn Crab",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_fish_prawn_crab.png",
      redirectUrl: "/casino/aggapjiligaming-fish-prawn-crab",
    },
    jili_lucky_jaguar: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Jaguar",
      name: "Lucky Jaguar",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_lucky_jaguar.png",
      redirectUrl: "/casino/aggapjiligaming-lucky-jaguar",
    },
    jili_shogun: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Shōgun",
      name: "Shōgun",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_shogun.png",
      redirectUrl: "/casino/aggapjiligaming-shogun",
    },
    jili_nightfall_hunting: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Nightfall Hunting",
      name: "Nightfall Hunting",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_nightfall_hunting.png",
      redirectUrl: "/casino/aggapjiligaming-nightfall-hunting",
    },
    jili_money_pot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Pot",
      name: "Money Pot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_money_pot.png",
      redirectUrl: "/casino/aggapjiligaming-money-pot",
    },
    jili_3_pot_dragons: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Pot Dragons",
      name: "3 Pot Dragons",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_3_pot_dragons.png",
      redirectUrl: "/casino/aggapjiligaming-3-pot-dragons",
    },
    jili_poseidon: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poseidon",
      name: "Poseidon",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_poseidon.png",
      redirectUrl: "/casino/aggapjiligaming-poseidon",
    },
    jili_3_lucky_piggy: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Lucky Piggy",
      name: "3 Lucky Piggy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_3_lucky_piggy.png",
      redirectUrl: "/casino/aggapjiligaming-3-lucky-piggy",
    },
    jili_egypts_glow: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Egypt's Glow",
      name: "Egypt's Glow",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_egypts_glow.png",
      redirectUrl: "/casino/aggapjiligaming-egypts-glow",
    },
    jili_party_star: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Party Star",
      name: "Party Star",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_party_star.png",
      redirectUrl: "/casino/aggapjiligaming-party-star",
    },
    jili_money_coming_expand_bets: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Coming Expand Bets",
      name: "Money Coming Expand Bets",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_money_coming_expand_bets.png",
      redirectUrl: "/casino/aggapjiligaming-money-coming-expand-bets",
    },
    jili_super_ace_deluxe: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Ace Deluxe",
      name: "Super Ace Deluxe",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_super_ace_deluxe.png",
      redirectUrl: "/casino/aggapjiligaming-super-ace-deluxe",
    },
    jili_legacy_of_egypt: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Legacy of Egypt",
      name: "Legacy of Egypt",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_legacy_of_egypt.png",
      redirectUrl: "/casino/aggapjiligaming-legacy-of-egypt",
    },
    jili_the_pig_house: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Pig House",
      name: "The Pig House",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_the_pig_house.png",
      redirectUrl: "/casino/aggapjiligaming-the-pig-house",
    },
    jili_crazy_hunter_2: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy Hunter 2",
      name: "Crazy Hunter 2",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_crazy_hunter_2.png",
      redirectUrl: "/casino/aggapjiligaming-crazy-hunter-2",
    },
    jili_fortune_king_jackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune King Jackpot",
      name: "Fortune King Jackpot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_fortune_king_jackpot.png",
      redirectUrl: "/casino/aggapjiligaming-fortune-king-jackpot",
    },
    video_poker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Video Poker",
      name: "Video Poker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/video_poker.webp",
      redirectUrl: "/casino/aggapjiligaming-video-poker",
    },
    caribbean_stud_poker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Caribbean Stud Poker",
      name: "Caribbean Stud Poker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/caribbean_stud_poker.webp",
      redirectUrl: "/casino/aggapjiligaming-caribbean-stud-poker",
    },
    pool_rummy: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pool Rummy",
      name: "Pool Rummy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/pool_rummy.webp",
      redirectUrl: "/casino/aggapjiligaming-pool-rummy",
    },
    mini_flush: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "MINI FLUSH",
      name: "MINI FLUSH",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mini_flush.webp",
      redirectUrl: "/casino/aggapjiligaming-mini-flush",
    },

    crash_bonus: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Bonus",
      name: "Crash Bonus",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crash_bonus.webp",
      redirectUrl: "/casino/aggapjiligaming-crash-bonus",
    },
    plinko: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Plinko",
      name: "Plinko",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/plinko.webp",
      redirectUrl: "/casino/aggapjiligaming-plinko",
    },
    keno: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Keno",
      name: "Keno",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/keno.webp",
      redirectUrl: "/casino/aggapjiligaming-keno",
    },
    mines_gold: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mines Gold",
      name: "Mines Gold",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mines_gold.webp",
      redirectUrl: "/casino/aggapjiligaming-mines-gold",
    },
    speed_baccarat: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Speed Baccarat",
      name: "Speed Baccarat",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/speed_baccarat.webp",
      redirectUrl: "/casino/aggapjiligaming-speed-baccarat",
    },
    jogo_do_bicho: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jogo do Bicho",
      name: "Jogo do Bicho",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jogo_do_bicho.webp",
      redirectUrl: "/casino/aggapjiligaming-jogo-do-bicho",
    },

    pearls_of_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pearls of Bingo",
      name: "Pearls of Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/pearls_of_bingo.webp",
      redirectUrl: "/casino/aggapjiligaming-pearls-of-bingo",
    },
    magiclamp_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Magic Lamp Bingo",
      name: "Magic Lamp Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/magiclamp_bingo.webp",
      redirectUrl: "/casino/aggapjiligaming-magic-lamp-bingo",
    },
    color_prediction: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Color Prediction",
      name: "Color Prediction",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/color_prediction.webp",
      redirectUrl: "/casino/aggapjiligaming-color-prediction",
    },
    candyland_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Candyland Bingo",
      name: "Candyland Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/candyland_bingo.webp",
      redirectUrl: "/casino/aggapjiligaming-candyland-bingo",
    },
    potion_wizard: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Potion Wizard",
      name: "Potion Wizard",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/potion_wizard.webp",
      redirectUrl: "/casino/aggapjiligaming-potion-wizard",
    },
    coin_treasures3: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Coin Treasures",
      name: "3 Coin Treasures",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/3_coin_treasures.webp",
      redirectUrl: "/casino/aggapjiligaming-3-coin-treasures",
    },
    fortune_gems_3: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Gems 3",
      name: "Fortune Gems 3",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortune_gems_3.webp",
      redirectUrl: "/casino/aggapjiligaming-fortune-gems-3",
    },
    jackpot_joker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jackpot Joker",
      name: "Jackpot Joker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jackpot_joker.webp",
      redirectUrl: "/casino/aggapjiligaming-jackpot-joker",
    },
    zeus: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Zeus",
      name: "Zeus",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/zeus.webp",
      redirectUrl: "/casino/aggapjiligaming-zeus",
    },
    devil_fire_2: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Devil Fire 2",
      name: "Devil Fire 2",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/devil_fire_2.webp",
      redirectUrl: "/casino/aggapjiligaming-devil-fire-2",
    },
    trial_of_phoenix: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trial of Phoenix",
      name: "Trial of Phoenix",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/trial_of_phoenix.webp",
      redirectUrl: "/casino/aggapjiligaming-trial-of-phoenix",
    },
    arena_fighter: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Arena Fighter",
      name: "Arena Fighter",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/arena_fighter.webp",
      redirectUrl: "/casino/aggapjiligaming-arena-fighter",
    },
    witches_night: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Witches Night",
      name: "Witches Night",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/witches_night.webp",
      redirectUrl: "/casino/aggapjiligaming-witches-night",
    },
    charge_buffalo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Charge Buffalo Ascent",
      name: "Charge Buffalo Ascent",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/charge_buffalo.webp",
      redirectUrl: "/casino/aggapjiligaming-charge-buffalo-ascent",
    },
    king_arthur: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "King Arthur",
      name: "King Arthur",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/king_arthur.webp",
      redirectUrl: "/casino/aggapjiligaming-king-arthur",
    },
    sin_city: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sin City",
      name: "Sin City",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/sin_city.webp",
      redirectUrl: "/casino/aggapjiligaming-sin-city",
    },
    dabangg: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dabanggg",
      name: "Dabanggg",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/dabangg.webp",
      redirectUrl: "/casino/aggapjiligaming-dabanggg",
    },
    fortune_monkey: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Monkey",
      name: "Fortune Monkey",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortune_monkey.webp",
      redirectUrl: "/casino/aggapjiligaming-fortune-monkey",
    },
    aztec_priestess: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Aztec Priestess",
      name: "Aztec Priestess",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/aztec_priestess.webp",
      redirectUrl: "/casino/aggapjiligaming-aztec-priestess",
    },
    bangla_beauty: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bangla Beauty",
      name: "Bangla Beauty",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bangla_beauty.webp",
      redirectUrl: "/casino/aggapjiligaming-bangla-beauty",
    },
    devil_fire: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Devil Fire",
      name: "Devil Fire",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/devil_fire.webp",
      redirectUrl: "/casino/aggapjiligaming-devil-fire",
    },
    golden_temple: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Temple",
      name: "Golden Temple",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/golden_temple.webp",
      redirectUrl: "/casino/aggapjiligaming-golden-temple",
    },
    cricket_sah_75: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Sah 75",
      name: "Cricket Sah 75",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/cricket_sah_75.webp",
      redirectUrl: "/casino/aggapjiligaming-cricket-sah-75",
    },
    elf_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Elf Bingo",
      name: "Elf Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/elf_bingo.webp",
      redirectUrl: "/casino/aggapjiligaming-elf-bingo",
    },
    cricket_king_18: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket King 18",
      name: "Cricket King 18",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/cricket_king_18.webp",
      redirectUrl: "/casino/aggapjiligaming-cricket-king-18",
    },
    sweet_land: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sweet Land",
      name: "Sweet Land",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/sweet_land.webp",
      redirectUrl: "/casino/aggapjiligaming-sweet-land",
    },
    fortune_gems_2: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Gems 2",
      name: "Fortune Gems 2",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortune_gems_2.webp",
      redirectUrl: "/casino/aggapjiligaming-fortune-gems-2",
    },
    diamond_city: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "DiamondParty",
      name: "DiamondParty",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/diamondparty.webp",
      redirectUrl: "/casino/aggapjiligaming-diamondparty",
    },
    night_city: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Night City",
      name: "Night City",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/nightcity.webp",
      redirectUrl: "/casino/aggapjiligaming-night-city",
    },
    hawaii_beauty: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hawaii Beauty",
      name: "Hawaii Beauty",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/hawaibeauty.webp",
      redirectUrl: "/casino/aggapjiligaming-hawaii-beauty",
    },
    ocean_king_jackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ocean King Jackpot",
      name: "Ocean King Jackpot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/oceankingjackpot.webp",
      redirectUrl: "/casino/aggapjiligaming-ocean-king-jackpot",
    },
    jili_pusoy_go: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pusoy Go",
      name: "Pusoy Go",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/pusoygo.webp",
      redirectUrl: "/casino/aggapjiligaming-pusoy-go",
    },
    jili_tongits_go: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tongits Go",
      name: "Tongits Go",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/tongitsgo.webp",
      redirectUrl: "/casino/aggapjiligaming-tongits-go",
    },
    jili_ludo_quick: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ludo Quick",
      name: "Ludo Quick",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ludoquick.webp",
      redirectUrl: "/casino/aggapjiligaming-ludo-quick",
    },
    jili_teenpatti_2020: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TeenPatti 20-20",
      name: "TeenPatti 20-20",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/teenpatti2020.webp",
      redirectUrl: "/casino/aggapjiligaming-teenpatti-20-20",
    },
    jili_callbreak_quick: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Callbreak Quick",
      name: "Callbreak Quick",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/callbreakquick.webp",
      redirectUrl: "/casino/aggapjiligaming-callbreak-quick",
    },
    jili_teenpatti_joker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TeenPatti Joker",
      name: "TeenPatti Joker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/teenpattijocker.webp",
      redirectUrl: "/casino/aggapjiligaming-teenpatti-joker",
    },
    jili_callbreak: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Callbreak",
      name: "Callbreak",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/CallBreak.webp",
      redirectUrl: "/casino/aggapjiligaming-callbreak",
    },
    jili_wheel: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wheel",
      name: "Wheel",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Wheel.webp",
      redirectUrl: "/casino/aggapjiligaming-wheel",
    },
    jili_limbo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Limbo",
      name: "Limbo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_limbo.webp",
      redirectUrl: "/casino/aggapjiligaming-limbo",
    },
    jili_golden_land: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Land",
      name: "Golden Land",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_golden_land.webp",
      redirectUrl: "/casino/aggapjiligaming-golden-land",
    },
    jili_bingo_adventure: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bingo Adventure",
      name: "Bingo Adventure",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jili_bingo_adventure.webp",
      redirectUrl: "/casino/aggapjiligaming-bingo-adventure",
    },
    jili_hilo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "HILO",
      name: "HILO",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/hilo.webp",
      redirectUrl: "/casino/aggapjiligaming-hilo",
    },
    jili_tower: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tower",
      name: "Tower",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Tower.webp",
      redirectUrl: "/casino/aggapjiligaming-tower",
    },
    jili_mines: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mines",
      name: "Mines",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mines.webp",
      redirectUrl: "/casino/aggapjiligaming-mines",
    },
    jili_go_rush: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Go Rush",
      name: "Go Rush",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/GoRush.webp",
      redirectUrl: "/casino/aggapjiligaming-go-rush",
    },
    jili_west_hunter_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "West Hunter Bingo",
      name: "West Hunter Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Westhunterbingogolden.webp",
      redirectUrl: "/casino/aggapjiligaming-west-hunter-bingo",
    },
    jili_pappu: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "PAPPU",
      name: "PAPPU",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Pappu.webp",
      redirectUrl: "/casino/aggapjiligaming-pappu",
    },
    jili_calaca_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Calaca Bingo",
      name: "Calaca Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Calacabingo.webp",
      redirectUrl: "/casino/aggapjiligaming-calaca-bingo",
    },

    jili_win_drop: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Win Drop",
      name: "Win Drop",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/WinDrop.webp",
      redirectUrl: "/casino/aggapjiligaming-win-drop",
    },
    jili_bingo_carnaval: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bingo Carnaval",
      name: "Bingo Carnaval",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BingoCarnaval.webp",
      redirectUrl: "/casino/aggapjiligaming-bingo-carnaval",
    },
    jili_super_bingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Bingo",
      name: "Super Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/SuperBingo.webp",
      redirectUrl: "/casino/aggapjiligaming-super-bingo",
    },

    jili_big_small: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Big Small",
      name: "Big Small",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BigSmall.webp",
      redirectUrl: "/casino/aggapjiligaming-big-small",
    },

    jili_crazy_pusher: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy Pusher",
      name: "Crazy Pusher",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crazypusher.webp",
      redirectUrl: "/casino/aggapjiligaming-crazy-pusher",
    },

    jili_mega_ace: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mega Ace",
      name: "Mega Ace",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/MegaAce.webp",
      redirectUrl: "/casino/aggapjiligaming-mega-ace",
    },
    jili_dinosaur_tycoon_II: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dinosaur Tycoon II",
      name: "Dinosaur Tycoon II",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/DinosaurTycoon.webp",
      redirectUrl: "/casino/aggapjiligaming-dinosaur-tycoon-ii",
    },
    jili_sicbo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sic Bo",
      name: "Sic Bo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Sicbo.webp",
      redirectUrl: "/casino/aggapjiligaming-sic-bo",
    },
    jili_7up7down: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "7up7down",
      name: "7up7down",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/7up7Down.webp",
      redirectUrl: "/casino/aggapjiligaming-7up7down",
    },
    Jili_Journey_West_M: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Journey West M",
      name: "Journey West M",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/journeywestM.webp",
      redirectUrl: "/casino/aggapjiligaming-journey-west-m",
    },
    Jili_Ali_Baba: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ali Baba",
      name: "Ali Baba",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/alibaba.webp",
      redirectUrl: "/casino/aggapjiligaming-ali-baba",
    },
    Jili_Twin_Wins: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TWIN WINS",
      name: "TWIN WINS",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/twinwins.webp",
      redirectUrl: "/casino/aggapjiligaming-twin-wins",
    },
    Jili_Agent_Ace: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Agent Ace",
      name: "Agent Ace",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/agentace.webp",
      redirectUrl: "/casino/aggapjiligaming-agent-ace",
    },
    Jili_Magic_Lamp: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Magic Lamp",
      name: "Magic Lamp",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/magiclamb.webp",
      redirectUrl: "/casino/aggapjiligaming-magic-lamp",
    },
    Jili_Party_Night: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Party Night",
      name: "Party Night",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/partynight.webp",
      redirectUrl: "/casino/aggapjiligaming-party-night",
    },
    Jili_Crazy_Hunter: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy Hunter",
      name: "Crazy Hunter",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crazyhunter.webp",
      redirectUrl: "/casino/aggapjiligaming-crazy-hunter",
    },
    Jili_All_Star_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "All-star Fishing",
      name: "All-star Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/allstarfishing.webp",
      redirectUrl: "/casino/aggapjiligaming-all-star-fishing",
    },
    Jili_Golden_Empire: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Empire",
      name: "Golden Empire",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Goldenempire.webp",
      redirectUrl: "/casino/aggapjiligaming-golden-empire",
    },
    Jili_Roma_X: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "RomaX",
      name: "RomaX",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/RomaX.webp",
      redirectUrl: "/casino/aggapjiligaming-romax",
    },
    Jili_Super_Rich: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Rich",
      name: "Super Rich",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/SuperRich.webp",
      redirectUrl: "/casino/aggapjiligaming-super-rich",
    },
    Jili_Lucky_Coming: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Coming",
      name: "Lucky Coming",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckycoming.webp",
      redirectUrl: "/casino/aggapjiligaming-lucky-coming",
    },
    Jili_Pharaoh_Treasure: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pharaoh Treasure",
      name: "Pharaoh Treasure",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/pharaohtreasure.webp",
      redirectUrl: "/casino/aggapjiligaming-pharaoh-treasure",
    },
    Jili_Secret_Treasure: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Secret Treasure",
      name: "Secret Treasure",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Secreatetreasure.webp",
      redirectUrl: "/casino/aggapjiligaming-secret-treasure",
    },
    Jili_Boxing_King: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Boxing King",
      name: "Boxing King",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BoxingKing.webp",
      redirectUrl: "/casino/aggapjiligaming-boxing-king",
    },
    Jili_Jungle_King: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jungle King",
      name: "Jungle King",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Jungleking.webp",
      redirectUrl: "/casino/aggapjiligaming-jungle-king",
    },
    Jili_Money_Coming: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Coming",
      name: "Money Coming",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/MoneyComing.webp",
      redirectUrl: "/casino/aggapjiligaming-money-coming",
    },
    Jili_Monkey_Party: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Monkey Party",
      name: "Monkey Party",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/MonkeyParty.webp",
      redirectUrl: "/casino/aggapjiligaming-monkey-party",
    },
    Jili_Golden_Queen: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Queen",
      name: "Golden Queen",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Goldenqueen.webp",
      redirectUrl: "/casino/aggapjiligaming-golden-queen",
    },
    Jili_Super_Ace: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Ace",
      name: "Super Ace",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/SuperAce.webp",
      redirectUrl: "/casino/aggapjiligaming-super-ace",
    },
    Jili_Charge_Buffalo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Charge Buffalo",
      name: "Charge Buffalo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/charge_buffalo.webp",
      redirectUrl: "/casino/aggapjiligaming-charge-buffalo",
    },
    Jili_Dragon_Treasure: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Treasure",
      name: "Dragon Treasure",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/dragontreasure.webp",
      redirectUrl: "/casino/aggapjiligaming-dragon-treasure",
    },
    Jili_Lucky_Goldbricks: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Goldbricks",
      name: "Lucky Goldbricks",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckygoldbricks.webp",
      redirectUrl: "/casino/aggapjiligaming-lucky-goldbricks",
    },
    Jili_Crazy_Golden_Bank: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy Golden Bank",
      name: "Crazy Golden Bank",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/CrazyGoldenBank.webp",
      redirectUrl: "/casino/aggapjiligaming-crazy-golden-bank",
    },

    Jili_Feng_Shen: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fengshen",
      name: "Fengshen",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/FengShen.webp",
      redirectUrl: "/casino/aggapjiligaming-fengshen",
    },
    Jili_Candy_Baby: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Candy Baby",
      name: "Candy Baby",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/candyBaby.webp",
      redirectUrl: "/casino/aggapjiligaming-candy-baby",
    },
    Jili_Fortune_Pig: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "FortunePig",
      name: "FortunePig",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/FortunePig.webp",
      redirectUrl: "/casino/aggapjiligaming-fortunepig",
    },
    Jili_Xiyangyang: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "XiYangYang",
      name: "XiYangYang",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Xiyangyang.webp",
      redirectUrl: "/casino/aggapjiligaming-xiyangyang",
    },
    Jili_Crazy_fafafa: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy FaFaFa",
      name: "Crazy FaFaFa",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Crazyfafafa.webp",
      redirectUrl: "/casino/aggapjiligaming-crazy-fafafa",
    },
    Jili_Bao_Boon_Chin: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bao boon chin",
      name: "Bao boon chin",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BaoBoonChin.webp",
      redirectUrl: "/casino/aggapjiligaming-bao-boon-chin",
    },
    Jili_777: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "SevenSevenSeven",
      name: "SevenSevenSeven",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/SevenSevenSeven.webp",
      redirectUrl: "/casino/aggapjiligaming-sevensevenseven",
    },
    Jili_God_of_Martial: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "God Of Martial",
      name: "God Of Martial",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/GodofMartial.webp",
      redirectUrl: "/casino/aggapjiligaming-god-of-martial",
    },
    Jili_FaFaFa: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fa Fa Fa",
      name: "Fa Fa Fa",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Fafafa.webp",
      redirectUrl: "/casino/aggapjiligaming-fa-fa-fa",
    },
    Jili_Shanghai_Beauty: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Shanghai Beauty",
      name: "Shanghai Beauty",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/shanghaibeauty.webp",
      redirectUrl: "/casino/aggapjiligaming-shanghai-beauty",
    },
    Jili_Hyper_Burst: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hyper Burst",
      name: "Hyper Burst",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/HyperBurst.webp",
      redirectUrl: "/casino/aggapjiligaming-hyper-burst",
    },
    Jili_Lucky_Ball: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Ball",
      name: "Lucky Ball",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/LuckyBall.webp",
      redirectUrl: "/casino/aggapjiligaming-lucky-ball",
    },
    Jili_Fortune_Tree: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Tree",
      name: "Fortune Tree",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/FortuneTree.webp",
      redirectUrl: "/casino/aggapjiligaming-fortune-tree",
    },
    Jili_War_of_Drangons: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "War Of Dragons",
      name: "War Of Dragons",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/warofdragons.webp",
      redirectUrl: "/casino/aggapjiligaming-war-of-dragons",
    },
    Jili_Chin_Shj_Huang: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Chin Shi Huang",
      name: "Chin Shi Huang",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/chinshihuang.webp",
      redirectUrl: "/casino/aggapjiligaming-chin-shi-huang",
    },
    Jili_Hot_Chilli: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Chilli",
      name: "Hot Chilli",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Hotchilli.webp",
      redirectUrl: "/casino/aggapjiligaming-hot-chilli",
    },
    Jili_Gem_Party: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gem Party",
      name: "Gem Party",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/GemParty.webp",
      redirectUrl: "/casino/aggapjiligaming-gem-party",
    },

    Jili_Number_King: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Number King",
      name: "Number King",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/numberking.webp",
      redirectUrl: "/casino/aggapjiligaming-number-king-u6989",
    },
    Jili_Rummy: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rummy",
      name: "Rummy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Rummy.webp",
      redirectUrl: "/casino/aggapjiligaming-rummy-u7364",
    },
    Jili_Andar_Bahar: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/AndarBahar.webp",
      redirectUrl: "/casino/aggapjiligaming-andar-bahar-u6903",
    },
    Jili_AK47: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "AK47",
      name: "AK47",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/AK47.webp",
      redirectUrl: "/casino/aggapjiligaming-ak47-u2970",
    },
    Jili_Teen_Patti: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TeenPatti",
      name: "TeenPatti",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Teenpatti.webp",
      redirectUrl: "/casino/aggapjiligaming-teenpatti-u7595",
    },
    Jili_Poker_King: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker King",
      name: "Poker King",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/pokerking.webp",
      redirectUrl: "/casino/aggapjiligaming-poker-king",
    },
    Jili_Lucky_Number: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Number",
      name: "Lucky Number",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/LuckyNumber.webp",
      redirectUrl: "/casino/aggapjiligaming-lucky-number",
    },
    Jili_7_UpDown: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "7 UP-DOWN",
      name: "7 UP-DOWN",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/7UpDown.webp",
      redirectUrl: "/casino/aaggapjiligaming-7-up-down",
    },
    Jili_Dice: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice",
      name: "Dice",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Dice.webp",
      redirectUrl: "/casino/aggapjiligaming-dice",
    },
    Jili_DragonTiger: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon & Tiger",
      name: "Dragon & Tiger",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/DragonandTiger.webp",
      redirectUrl: "/casino/aggapjiligaming-dragon-and-tiger",
    },
    Jili_Fairness_Games: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fairness Games",
      name: "Fairness Games",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/FairnessGames.webp",
      redirectUrl: "/casino/aggapjiligaming-fairness-games",
    },
    Jili_Happy_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Happy Fishing",
      name: "Happy Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/happyFishing.webp",
      redirectUrl: "/casino/aggapjiligaming-happy-fishing",
    },
    Jili_Boom_Legend: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Boom Legend",
      name: "Boom Legend",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BoomLegend.webp",
      redirectUrl: "/casino/aggapjiligaming-boom-legend",
    },
    Jili_Mega_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mega Fishing",
      name: "Mega Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Megafishing.webp",
      redirectUrl: "/casino/aggapjiligaming-mega-fishing",
    },
    Jili_Dragon_Fortune: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Fortune",
      name: "Dragon Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/DragonFortune.webp",
      redirectUrl: "/casino/aggapjiligaming-dragon-fortune",
    },
    Jili_Jackpot_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jackpot Fishing",
      name: "Jackpot Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/JackpotFishing.webp",
      redirectUrl: "/casino/aggapjiligaming-jackpot-fishing",
    },
    Jili_Dinosaur_Tycoon: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dinosaur Tycoon",
      name: "Dinosaur Tycoon",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/DinosaurTycoon.webp",
      redirectUrl: "/casino/aggapjiligaming-dinosaur-tycoon",
    },
    Jili_Bombing_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bombing Fishing",
      name: "Bombing Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/BombingFishing.webp",
      redirectUrl: "/casino/aggapjiligaming-bombing-fishing",
    },
    Jili_Royal_Fishing: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Royal Fishing",
      name: "Royal Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/RoyalFishing.webp",
      redirectUrl: "/casino/aggapjiligaming-royal-fishing",
    },
  },
  jilivirtual: {
    dominogo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Domino Go",
      name: "Domino Go",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/dominogo.webp",
      redirectUrl: "/casino/aggapjiligaming-domino-go",
    },
    blackjack_lucky_ladies: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack Lucky Ladies",
      name: "Blackjack Lucky Ladies",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/blackjack_lucky_ladies.webp",
      redirectUrl: "/casino/aggapjiligaming-blackjack-lucky-ladies",
    },
    blackjack: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack",
      name: "Blackjack",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/blackjack.webp",
      redirectUrl: "/casino/aggapjiligaming-blackjack",
    },
    european_roulette: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "European Roulette",
      name: "European Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/european_roulette.webp",
      redirectUrl: "/casino/aggapjiligaming-european-roulette",
    },
  },
  mac88Gaming: {
    RockPaperScissors: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rock Paper Scissors",
      name: "Rock Paper Scissors",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/rockpaperscissors.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
    },
    Boys5: {
      code: "67720",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5 Boys",
      name: "5 Boys",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/5boys.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-5-boys",
    },
    JetXT: {
      code: "92037",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jet XT",
      name: "Jet XT",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/jetxt.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-jet-xt",
    },
    Kitex: {
      code: "92038",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Kitex",
      name: "Kitex",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/kitex.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-kitex",
    },
    HiLo: {
      code: "67610",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hi Lo",
      name: "Hi Lo",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/hi-lo.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo",
    },
    PushpaRani: {
      code: "67670",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pushpa Rani",
      name: "Pushpa Rani",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/pushparani.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-pushpa-rani",
    },
    BallbyBallVR: {
      code: "90100",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ball by Ball VR",
      name: "Ball by Ball VR",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/ballbyballvr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
    },
    XRoulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "X Roulette",
      name: "X Roulette",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/xroulette.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-x-roulette",
    },
    Lucky15: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 15",
      name: "Lucky 15",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/lucky15.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-lucky-15",
    },
    Vortex: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Vortex",
      name: "Vortex",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/vortex.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vortex",
    },
    BollyKiss: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bolly Kiss",
      name: "Bolly Kiss",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/bollykiss.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-bolly-kiss",
    },
    Plinko: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Plinko",
      name: "Plinko",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/plinko.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-plinko",
    },
    diamonds: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Diamond",
      name: "Diamond",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/diamonds.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-diamonds",
    },
    mines: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mines",
      name: "Mines",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/mines.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-mines",
    },
    Limbo: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Limbo",
      name: "Limbo",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/limbo.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-limbo",
    },
    CrashX: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash X",
      name: "Crash X",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/crashx.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-crash-x",
    },
    Dice: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice",
      name: "Dice",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/Dice.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-dice",
    },
    AK47VR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "AK47 VR",
      name: "AK47 VR",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/ak47vr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ak47-vr",
    },
    KaunBanegaCrorepatiVR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Kaun Banega Crorepati VR",
      name: "Kaun Banega Crorepati VR",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/kaunabanegacrorpativr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-kaun-banega-crorepati-vr",
    },
    CenterCardVR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Center Card VR",
      name: "Center Card VR",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-center-card-vr",
    },
    UniqueTeenpatti: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Unique Teenpatti",
      name: "Unique Teenpatti",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/UTP.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-center-card-vr",
    },
    PoisonTeenpatti2020: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poison Teenpatti 20 20",
      name: "Poison Teenpatti 20 20",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/PTP.webp",
      redirectUrl: "/casino/aggapmac88gaming-poison-teenpatti-20-20",
    },
    TPJ2020: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti Joker 20 20",
      name: "Teenpatti Joker 20 20",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/TPJ2020.webp",
      redirectUrl: "/casino/aggapmac88gaming-teenpatti-joker-20-20",
    },
    auto_roulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Speed Auto Roulette",
      name: "Speed Auto Roulette",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/auto_roulette.webp",
      redirectUrl: "/casino/aggapmac88gaming-speed-auto-roulette",
    },
    turbo_roulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Turbo Auto Roulette",
      name: "Turbo Auto Roulette",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/turbo_roulette.webp",
      redirectUrl: "/casino/aggapmac88gaming-turbo-auto-roulette",
    },
    ak47tp: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "AK47 Teenpatti",
      name: "AK47 Teenpatti",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/ak47tp.webp",
      redirectUrl: "/casino/aggapmac88gaming-ak47-teenpatti",
    },
    lucky5: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 5",
      name: "Lucky 5",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/lucky5.webp",
      redirectUrl: "/casino/aggapmac88gaming-lucky-5",
    },
    dt2: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Tiger 2",
      name: "Dragon Tiger 2",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/dt2.webp",
      redirectUrl: "/casino/aggapmac88gaming-dragon-tiger-2",
    },
    tp22020: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "20 20 Teenpatti 2",
      name: "20 20 Teenpatti 2",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/2020tp2.webp",
      redirectUrl: "/casino/aggapmac88gaming-20-20-teenpatti-2",
    },
    dw: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dream Wheel",
      name: "Dream Wheel",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/dw.webp",
      redirectUrl: "/casino/aggapmac88gaming-dream-wheel",
    },
    fs: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Football StudIo",
      name: "Football StudIo",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/fs.webp",
      redirectUrl: "/casino/aggapmac88gaming-football-studio",
    },
    sbc: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Side Bet city",
      name: "Side Bet city",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/sbc.webp",
      redirectUrl: "/casino/aggapmac88gaming-side-bet-city",
    },
    cc: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Center card",
      name: "Center card",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/cc.webp",
      redirectUrl: "/casino/aggapmac88gaming-center-card",
    },
    so: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Over",
      name: "Super Over",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/so.webp",
      redirectUrl: "/casino/aggapmac88gaming-super-over-u5188",
    },
    ab50: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Andar Bahar 50",
      name: "Andar Bahar 50",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/ab50.webp",
      redirectUrl: "/casino/aggapmac88gaming-andar-bahar-50",
    },
    itp: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Instant Teen Patti",
      name: "Instant Teen Patti",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/itp.webp",
      redirectUrl: "/casino/aggapmac88gaming-instant-teen-patti",
    },
    iw: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Instant worli",
      name: "Instant worli",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/iw.webp",
      redirectUrl: "/casino/aggapmac88gaming-instant-worli",
    },
    mtp: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Muflis Teenpatti",
      name: "Muflis Teenpatti",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/mtp.webp",
      redirectUrl: "/casino/aggapmac88gaming-muflis-teenpatti-u7351",
    },
    cricket10_10_: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "10 - 10 cricket",
      name: "10 - 10 cricket",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/10_10_cricket.webp",
      redirectUrl: "/casino/aggapmac88gaming-10-10-cricket",
    },
    baccarat_one_day: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat One Day",
      name: "Baccarat One Day",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/baccarat_one_day.webp",
      redirectUrl: "/casino/aggapmac88gaming-baccarat-one-day",
    },
    high_low: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "High Low",
      name: "High Low",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/high_low.webp",
      redirectUrl: "/casino/aggapmac88gaming-high-low",
    },
    center_card_one_day: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Center Card One Day",
      name: "Center Card One Day",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/center_card_one_day.webp",
      redirectUrl: "/casino/aggapmac88gaming-center-card-one-day",
    },
    open_teen_patti: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Open Teen patti",
      name: "Open Teen patti",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/open_teen_patti.webp",
      redirectUrl: "/casino/aggapmac88gaming-open-teen-patti",
    },
    race_2: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race to 2nd",
      name: "Race to 2nd",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/race_2.webp",
      redirectUrl: "/casino/aggapmac88gaming-race-to-2nd",
    },
    cricket2020: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Match 20-20",
      name: "Cricket Match 20-20",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/cricket2020.webp",
      redirectUrl: "/casino/aggapmac88gaming-cricket-match-20-20",
    },
    notenumber: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Note Number",
      name: "Note Number",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/notenumber.webp",
      redirectUrl: "/casino/aggapmac88gaming-note-number",
    },
    race_17: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race to 17",
      name: "Race to 17",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/race_17.webp",
      redirectUrl: "/casino/aggapmac88gaming-race-to-17",
    },
    card_tp2: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Instant 2 Cards Teenpatti",
      name: "Instant 2 Cards Teenpatti",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/2_card_tp.webp",
      redirectUrl: "/casino/aggapmac88gaming-instant-2-cards-teenpatti",
    },
    pp6: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "6 Player Poker",
      name: "6 Player Poker",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/6pp.webp",
      redirectUrl: "/casino/aggapmac88gaming-6-player-poker",
    },
    cd11: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "One Card One Day",
      name: "One Card One Day",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/1c1d.webp",
      redirectUrl: "/casino/aggapmac88gaming-one-card-one-day",
    },
    card_meter_1: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "One Card Meter",
      name: "One Card Meter",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/1_card_meter.webp",
      redirectUrl: "/casino/aggapmac88gaming-one-card-meter",
    },
    card_20_20_1: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "One Card 20 20",
      name: "One Card 20 20",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/1_card_20_20.webp",
      redirectUrl: "/casino/aggapmac88gaming-one-card-20-20",
    },
    kadum10: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dus Ka Dum",
      name: "Dus Ka Dum",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/10kadum.webp",
      redirectUrl: "/casino/aggapmac88gaming-dus-ka-dum",
    },
    dt_1day: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "1 Day Dragon Tiger",
      name: "1 Day Dragon Tiger",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/dt_1day.webp",
      redirectUrl: "/casino/aggapmac88gaming-1-day-dragon-tiger",
    },
    five_cricket_5: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5 Five Cricket",
      name: "5 Five Cricket",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/5_five_cricket.webp",
      redirectUrl: "/casino/aggapmac88gaming-5-five-cricket",
    },
    teenpatti_20_20: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "20-20 Teenpatti",
      name: "20-20 Teenpatti",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/20_20_teenpatti.webp",
      redirectUrl: "/casino/aggapmac88gaming-20-20-teenpatti",
    },
    poker_1_day: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker 1-Day",
      name: "Poker 1-Day",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/poker_1_day.webp",
      redirectUrl: "/casino/aggapmac88gaming-poker-1-day",
    },
    bollywood_casino: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bollywood Casino B",
      name: "Bollywood Casino B",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/bollywood_casino.webp",
      redirectUrl: "/casino/aggapmac88gaming-bollywood-casino-b",
    },
    cards_teenpatti_2: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Two Card Teenpatti",
      name: "Two Card Teenpatti",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/2_cards_teenpatti.webp",
      redirectUrl: "/casino/aggapmac88gaming-two-card-teenpatti",
    },
    b29: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "29 Baccarat",
      name: "29 Baccarat",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/29b.webp",
      redirectUrl: "/casino/aggapmac88gaming-29-baccarat",
    },
    trio: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trio",
      name: "Trio",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/trio.webp",
      redirectUrl: "/casino/aggapmac88gaming-trio",
    },
    teenpatti_test: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Test Teenpatti",
      name: "Test Teenpatti",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/teenpatti_test.webp",
      redirectUrl: "/casino/aggapmac88gaming-test-teenpatti",
    },
    lottery: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lottery",
      name: "Lottery",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/lottery.webp",
      redirectUrl: "/casino/aggapmac88gaming-lottery",
    },
    worli_matka: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Worli Matka",
      name: "Worli Matka",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/worli_matka.webp",
      redirectUrl: "/casino/aggapmac88gaming-worli-matka",
    },
    casino_war: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Casino War",
      name: "Casino War",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/casino_war.webp",
      redirectUrl: "/casino/aggapmac88gaming-casino-war",
    },
    race_20: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race 20",
      name: "Race 20",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/race_20.webp",
      redirectUrl: "/casino/aggapmac88gaming-race-20",
    },
    queen: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Queen Race",
      name: "Queen Race",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/queen.webp",
      redirectUrl: "/casino/aggapmac88gaming-queen-race",
    },
    cj3: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Cards Judgement",
      name: "3 Cards Judgement",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/3cj.webp",
      redirectUrl: "/casino/aggapmac88gaming-3-cards-judgement",
    },
    amar_akbar_anthony: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Amar Akbar Anthony",
      name: "Amar Akbar Anthony",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/amar_akbar_anthony.webp",
      redirectUrl: "/casino/aggapmac88gaming-amar-akbar-anthony",
    },
    dtl_20_20: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Tiger Lion",
      name: "Dragon Tiger Lion",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/dtl_20_20.webp",
      redirectUrl: "/casino/aggapmac88gaming-dtl",
    },
    cards32: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "32 Cards",
      name: "32 Cards",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/32_cards.webp",
      redirectUrl: "/casino/aggapmac88gaming-32-cards",
    },
    tp1d: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti One Day",
      name: "Teenpatti One Day",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/tp1d.webp",
      redirectUrl: "/casino/aggapmac88gaming-teenpatti-one-day",
    },
    andar_bahar: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/andar_bahar.webp",
      redirectUrl: "/casino/aggapmac88gaming-andar-bahar",
    },
    lucky_7: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky7",
      name: "Lucky7",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/lucky_7.webp",
      redirectUrl: "/casino/aggapmac88gaming-lucky7",
    },
    poker2020: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker 20-20",
      name: "Poker 20-20",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/20_20_poker.webp",
      redirectUrl: "/casino/aggapmac88gaming-poker-20-20",
    },
    roulette_mac88: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Roulette",
      name: "Roulette",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/roulette_mac88.webp",
      redirectUrl: "/casino/aggapmac88gaming-roulette",
    },
    sicbo_mac88: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sic Bo",
      name: "Sic Bo",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/sicbo_mac88.webp",
      redirectUrl: "/casino/aggapmac88gaming-sic-bo",
    },
    baccarat_mac88: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bacarrat",
      name: "Bacarrat",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/baccarat_mac88.webp",
      redirectUrl: "/casino/aggapmac88gaming-bacarrat",
    },
    dt_mac88: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
      providerName: "Mac88 Gaming",
      imgUrl: "./images/alt-gaming/mac88/dt_mac88.webp",
      redirectUrl: "/casino/aggapmac88gaming-dragon-tiger",
    },

    // HiloVR: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Hi Lo VR",
    //   name: "Hi Lo VR",
    //   providerName: "Mac88 Gaming",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo-vr",
    // },
    // AviatorX2: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "AviatorX2",
    //   name: "AviatorX2",
    //   providerName: "Mac88 Gaming",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-aviatorx2",
    // },
    // K3Lottery10: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "K3 Lottery 10",
    //   name: "K3 Lottery 10",
    //   providerName: "Mac88 Gaming",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
    // },
  },
  mac88gamingvirtual: {
    ChickenRoadCross: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-chicken-road-cross",
      code: "",
      casino: "ezugi",
      provider: "",
      imgUrl: "./images/popular/new/chickyroadcross.webp",
      alt: "Chicken Road Cross",
      name: "Chicken Road Cross",
    },
    crashman: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "CRASH MAN",
      name: "CRASH MAN",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/crashman.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-crash-man",
    },
    Packs: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Packs",
      name: "Packs",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/packs.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-packs",
    },
    dragontower: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Tower",
      name: "Dragon Tower",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/dragontower.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-dragon-tower",
    },
    Pump: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pump",
      name: "Pump",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/pump.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-pump",
    },
    jalwacolorgame10: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jalwa Color Game 10",
      name: "Jalwa Color Game 10",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/jalwacolorgame.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-jalwa-color-game-10",
    },
    jalwacolorgame5: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jalwa Color Game 5",
      name: "Jalwa Color Game 5",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/jalwacolorgame.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-jalwa-color-game-5",
    },
    jalwacolorgame3: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jalwa Color Game 3",
      name: "Jalwa Color Game 3",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/jalwacolorgame.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-jalwa-color-game-3",
    },
    jalwacolorgame: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jalwa Color Game",
      name: "Jalwa Color Game",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/jalwacolorgame.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-jalwa-color-game",
    },
    naughtybutton: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Naughty Button",
      name: "Naughty Button",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/naughtybutton.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-naughty-button",
    },
    racetrack: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race Track",
      name: "Race Track",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/racetrack.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-race-track",
    },
    pick3: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pick3 3min",
      name: "Pick3 3min",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/pick3.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-pick3-3min",
    },
    pick1: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pick3 1min",
      name: "Pick3 1min",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/pick3.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-pick3-1min",
    },
    stockmatka: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Stock Matka",
      name: "Stock Matka",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/stockmatka.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-stock-matka",
    },
    JhandiMunda: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jhandi Munda",
      name: "Jhandi Munda",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/stockmatka.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-jhandi-munda",
    },
    val1: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5 Boys",
      name: "5 Boys",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/val1.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-5-boys",
    },
    bbb: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ball by Ball VR",
      name: "Ball by Ball VR",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/bbb.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
    },
    lucky15: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 15",
      name: "Lucky 15",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/lucky15.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-lucky-15",
    },
    bk1: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bolly Kiss",
      name: "Bolly Kiss",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/bk1.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-bolly-kiss",
    },
    vlucky5: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 5",
      name: "Lucky 5",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vlucky5.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-lucky-5",
    },
    plinko: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Plinko",
      name: "Plinko",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/plinko.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-plinko",
    },
    ak47_vr: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "AK47 VR",
      name: "AK47 VR",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/ak47_vr.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ak47-vr",
    },
    kbc_vr: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Kaun Banega Crorepati VR",
      name: "Kaun Banega Crorepati VR",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/kbc_vr.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-kaun-banega-crorepati-vr",
    },
    vr_cc: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Center Card VR",
      name: "Center Card VR",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_cc.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-center-card-vr",
    },
    vr_hc: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hi Lo VR",
      name: "Hi Lo VR",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_hc.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo-vr",
    },
    lotre_10k: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "K3 Lottery 10",
      name: "K3 Lottery 10",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/3k_lotre.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
    },
    lotre_5k: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "K3 Lottery 5",
      name: "K3 Lottery 5",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/3k_lotre.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-5",
    },
    lotre_3k: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "K3 Lottery 3",
      name: "K3 Lottery 3",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/3k_lotre.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-3",
    },
    lotre_1k: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "K3 Lottery 1",
      name: "K3 Lottery 1",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/3k_lotre.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-1",
    },
    sd_lotto10: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5D Lottery 10",
      name: "5D Lottery 10",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/sd_lotto.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-5d-lottery-10",
    },
    sd_lotto5: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5D Lottery 5",
      name: "5D Lottery 5",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/sd_lotto.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-5d-lottery-5",
    },
    sd_lotto3: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5D Lottery 3",
      name: "5D Lottery 3",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/sd_lotto.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-5d-lottery-3",
    },
    sd_lotto1: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5D Lottery 1",
      name: "5D Lottery 1",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/sd_lotto.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-5d-lottery-1",
    },
    sd_lotto1: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5D Lottery 1",
      name: "5D Lottery 1",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/sd_lotto.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-5d-lottery-1",
    },
    Wngo10: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-wingo10",
      code: "",
      casino: "Macc88 Gaming Virtula",
      provider: "",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/wingo-colorgame.webp",
      alt: "WINGO10",
      name: "WINGO10",
      providerName: "ALT_GAMING_GAP",
    },
    WINGO05: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-wingo5",
      code: "",
      casino: "Macc88 Gaming Virtula",
      provider: "",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/wingo-colorgame.webp",
      alt: "WINGO05",
      name: "WINGO05",
      providerName: "ALT_GAMING_GAP",
    },
    WINGO03: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-wingo3",
      code: "",
      casino: "Macc88 Gaming Virtula",
      provider: "",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/wingo-colorgame.webp",
      alt: "WINGO03",
      name: "WINGO03",
      providerName: "ALT_GAMING_GAP",
    },
    WINGO: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-wingo",
      code: "",
      casino: "Macc88 Gaming Virtula",
      provider: "",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/wingo-colorgame.webp",
      alt: "WINGO",
      name: "WINGO",
      providerName: "ALT_GAMING_GAP",
    },
    aviatorx: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-aviator-x",
      code: "",
      casino: "Macc88 Gaming Virtula",
      provider: "",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/aviatorx.webp",
      alt: "Aviator X",
      name: "Aviator X",
      providerName: "ALT_GAMING_GAP",
    },
    lk1: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lankesh",
      name: "Lankesh",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/lk1.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-lankesh",
    },
    vr_29b: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR 29 card bacarrat",
      name: "VR 29 card bacarrat",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_29b.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-29-card-bacarrat",
    },
    vr_worlimatka: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Worli Matka",
      name: "VR Worli Matka",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_worlimatka.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-worli-matka",
    },
    vr_hilo: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR High low",
      name: "VR High low",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_hilo.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-high-low",
    },
    vr_roulette: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Auto Roulette",
      name: "VR Auto Roulette",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_roulette.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-auto-roulette",
    },
    vr_race_20: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Race T20",
      name: "VR Race T20",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_race_20.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-race-t20",
    },
    vr_poker: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Poker",
      name: "VR Poker",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_poker.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-poker",
    },
    vr_queen: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Queen Race",
      name: "VR Queen Race",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_queen.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-queen-race",
    },
    vr_2ctp: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR 2 Card TP",
      name: "VR 2 Card TP",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_2ctp.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-2-card-tp",
    },
    vr_ab: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Andar Bahar",
      name: "VR Andar Bahar",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_ab.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-andar-bahar",
    },
    vr_32cards: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR 32 Cards",
      name: "VR 32 Cards",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_32cards.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-32-cards",
    },
    vr_tp2020: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR 20-20 Teenpatti",
      name: "VR 20-20 Teenpatti",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_tp2020.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-20-20-teenpatti",
    },
    vr_casinometer: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Casino Meter",
      name: "VR Casino Meter",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_casinometer.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-casino-meter",
    },
    vr_dragontiger: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Dragon Tiger",
      name: "VR Dragon Tiger",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_dragontiger.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-dragon-tiger",
    },
    vr_aaa: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Amar Akbar Anthony",
      name: "VR Amar Akbar Anthony",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_aaa.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-amar-akbar-anthony",
    },
    vr_bc: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Bollywood Casino",
      name: "VR Bollywood Casino",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_bc.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-bollywood-casino",
    },
    vr_mtp: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Mulfis Teenpatti",
      name: "VR Mulfis Teenpatti",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_mtp.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-mulfis-teenpatti",
    },
    vr_2020_dtl: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR 20-20 DTL",
      name: "VR 20-20 DTL",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_2020_dtl.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-20-20-dtl",
    },
    vr_trio: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Trio",
      name: "VR Trio",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_trio.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-trio",
    },
    vr_lucky7: {
      code: "67564",
      casino: "Macc88 Gaming Virtula",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VR Lucky 7",
      name: "VR Lucky 7",
      providerName: "ALT_GAMING_GAP",
      imgUrl: "./images/alt-gaming/mac888gming-virtual/vr_lucky7.webp",
      redirectUrl: "/casino/aaggapmac88gamingvirtual-vr-lucky-7",
    },
  },
  voltentGaming: {
    BellsEasterJackpots12: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "12 Bells Easter Jackpots",
      name: "12 Bells Easter Jackpots",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/12bellsEasterJackpots.jpg",
      redirectUrl: "/casino/aggapvoltent-12-bells-easter-jackpots",
    },
    CoinsGrandDiamondEditionEasterJackpots21: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "12 Coins Grand Diamond Edition Easter Jackpots",
      name: "12 Coins Grand Diamond Edition Easter Jackpots",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/12CoinsGrandDiamondEditionEasterJackpots.jpg",
      redirectUrl:
        "/casino/aggapvoltent-12-coins-grand-diamond-edition-easter-jackpots",
    },
    CoinsGrandPlatinumEditionEasterJackpots16: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "16 Coins Grand Platinum Edition Easter Jackpots",
      name: "16 Coins Grand Platinum Edition Easter Jackpots",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/16CoinsGrandPlatinumEditionEasterJackpots.jpg",
      redirectUrl:
        "/casino/aggapvoltent-16-coins-grand-platinum-edition-easter-jackpots",
    },
    CoinsGrandPlatinumEdition16: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "16 Coins Grand Platinum Edition",
      name: "16 Coins Grand Platinum Edition",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/16CoinsGrandPlatinumEdition.jpg",
      redirectUrl: "/casino/aggapvoltent-16-coins-grand-platinum-edition",
    },
    CoinsGrandGoldEditionEasterJackpots25: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "25 Coins Grand Gold Edition Easter Jackpots",
      name: "25 Coins Grand Gold Edition Easter Jackpots",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/25CoinsGrandGoldEditionEasterJackpots.jpg",
      redirectUrl:
        "/casino/aggapvoltent-25-coins-grand-gold-edition-easter-jackpots",
    },
    CoinsGrandGoldEdition25: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "25 Coins Grand Gold Edition",
      name: "25 Coins Grand Gold Edition",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/25CoinsGrandGoldEdition.jpg",
      redirectUrl: "/casino/aggapvoltent-25-coins-grand-gold-edition",
    },
    CoinsLovetheJackpot30: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "30 Coins Love the Jackpot",
      name: "30 Coins Love the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/30CoinsLovetheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-30-coins-love-the-jackpot",
    },
    CoinsEasterJackpots36: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "36 Coins Easter Jackpots",
      name: "36 Coins Easter Jackpots",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/36CoinsEasterJackpots.jpg",
      redirectUrl: "/casino/aggapvoltent-36-coins-easter-jackpots",
    },
    CoinsLovetheJackpot36: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "36 Coins Love the Jackpot",
      name: "36 Coins Love the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/36CoinsLovetheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-36-coins-love-the-jackpot",
    },
    HotSlot777GoldCrown: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Slot: 777 Gold Crown",
      name: "Hot Slot: 777 Gold Crown",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/HotSlot777GoldCrown.jpg",
      redirectUrl: "/casino/aggapvoltent-hot-slot-777-gold-crown",
    },
    HotSlot777HoldtheJackpot: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Slot: 777 Hold the Jackpot",
      name: "Hot Slot: 777 Hold the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/HotSlot777HoldtheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-hot-slot-777-hold-the-jackpot",
    },
    HotSlotGoldCoins: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Slot: Gold Coins",
      name: "Hot Slot: Gold Coins",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/HotSlotGoldCoins.jpg",
      redirectUrl: "/casino/aggapvoltent-hot-slot-gold-coins",
    },
    MightyFishBlueMarlinLovetheJackpot: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Fish: Blue Marlin Love the Jackpot",
      name: "Mighty Fish: Blue Marlin Love the Jackpot",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightyFishBlueMarlinLovetheJackpot.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-fish-blue-marlin-love-the-jackpot",
    },
    MightySymbolsJokersEasterJackpots: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Symbols: Jokers Easter Jackpots",
      name: "Mighty Symbols: Jokers Easter Jackpots",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightySymbolsJokersEasterJackpots.jpg",
      redirectUrl: "/casino/aggapvoltent-mighty-symbols-jokers-easter-jackpots",
    },
    MightySymbolsJokersLovetheJackpot: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Symbols: Jokers Love the Jackpot",
      name: "Mighty Symbols: Jokers Love the Jackpot",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightySymbolsJokersLovetheJackpot.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-symbols-jokers-love-the-jackpot",
    },
    MightyWildPantherGrandDiamondEditionEasterJackpots: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Wild: Panther Grand Diamond Edition Easter Jackpots",
      name: "Mighty Wild: Panther Grand Diamond Edition Easter Jackpots",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightyWildPantherGrandDiamondEditionEasterJackpots.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-wild-panther-grand-diamond-edition-easter-jackpots",
    },
    MightyWildPantherGrandDiamondEditionLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Wild: Panther Grand Diamond Edition Love the Jackpot",
      name: "Mighty Wild: Panther Grand Diamond Edition Love the Jackpot",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightyWildPantherGrandDiamondEditionLovetheJackpot.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-wild-panther-grand-diamond-edition-love-the-jackpot",
    },
    OneCoinEasterJackpots: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "One Coin Easter Jackpots",
      name: "One Coin Easter Jackpots",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/OneCoinEasterJackpots.jpg",
      redirectUrl: "/casino/aggapvoltent-one-coin-easter-jackpots",
    },
    OneCoinLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "One Coin Love the Jackpot",
      name: "One Coin Love the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/OneCoinLovetheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-one-coin-love-the-jackpot",
    },
    PowerofGodsHadesLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Power of Gods: Hades Love the Jackpot",
      name: "Power of Gods: Hades Love the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/PowerofGodsHadesLovetheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-power-of-gods-hades-love-the-jackpot",
    },
    PowerofSunSvargLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Power of Sun: Svarog Love the Jackpot",
      name: "Power of Sun: Svarog Love the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/PowerofSunSvargLovetheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-power-of-sun-svarog-love-the-jackpot",
    },
    SizzlingEggsGrandGoldEdition: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sizzling Eggs Grand Gold Edition",
      name: "Sizzling Eggs Grand Gold Edition",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/SizzlingEggsGrandGoldEdition.jpg",
      redirectUrl: "/casino/aggapvoltent-sizzling-eggs-grand-gold-edition",
    },
    MightyWildPantherGrandGoldEditionLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Wild: Panther Grand Gold Edition Love the Jackpot",
      name: "Mighty Wild: Panther Grand Gold Edition Love the Jackpot",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightyWildPantherGrandGoldEditionLovetheJackpot.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-wild-panther-grand-gold-edition-love-the-jackpot",
    },
    MightyWildPantherGrandPlatinumEditionLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Wild: Panther Grand Platinum Edition Love the Jackpot",
      name: "Mighty Wild: Panther Grand Platinum Edition Love the Jackpot",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightyWildPantherGrandPlatinumEditionLovetheJackpot.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-wild-panther-grand-platinum-edition-love-the-jackpot",
    },
  },
  iconic21Gaming: {
    AndarBahar: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/andarbahar.jpg",
      redirectUrl: "/casino/aggapiconic21-andar-bahar",
    },
    BaccaratTable2NoComission: {
      code: "67720",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat Table 2 No Comission",
      name: "Baccarat Table 2 No Comission",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/BaccaratTable2NoComission.jpg",
      redirectUrl: "/casino/aggapiconic21-baccarat-table-2-no-comission",
    },
    BaccaratTable2: {
      code: "92037",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat Table 2",
      name: "Baccarat Table 2",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/BaccaratTable2.jpg",
      redirectUrl: "/casino/aggapiconic21-baccarat-table-2",
    },
    blackjack360midnight: {
      code: "92038",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 360 Midnight",
      name: "Blackjack 360 Midnight",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/blackjack360midnight.jpg",
      redirectUrl: "/casino/aggapiconic21-blackjack-360-midnight",
    },
    blackjackmidday: {
      code: "67610",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 360 Midday",
      name: "Blackjack 360 Midday",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/blackjackmidday.jpg",
      redirectUrl: "/casino/aggapiconic21-blackjack-360-midday",
    },
    blackjacksunrise: {
      code: "67670",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 360 Sunrise",
      name: "Blackjack 360 Sunrise",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/blackjacksunrise.jpg",
      redirectUrl: "/casino/aggapiconic21-blackjack-360-sunrise",
    },
    blackjacksunset: {
      code: "90100",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 360 Sunset",
      name: "Blackjack 360 Sunset",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/blackjacksunset.jpg",
      redirectUrl: "/casino/aggapiconic21-blackjack-360-sunset",
    },
    cricketroulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Roulette",
      name: "Cricket Roulette",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/cricketroulette.jpg",
      redirectUrl: "/casino/aggapiconic21-cricket-roulette",
    },
    dragontiger: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Virtual Dragon Tiger",
      name: "Virtual Dragon Tiger",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/dragontiger.jpg",
      redirectUrl: "/casino/aggapiconic21-virtual-dragon-tiger",
    },
    grandbonusblackjack: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Grand Bonus Blackjack",
      name: "Grand Bonus Blackjack",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/grandbonusblackjack.jpg",
      redirectUrl: "/casino/aggapiconic21-grand-bonus-blackjack",
    },
    gravityblackjack: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gravity Blackjack",
      name: "Gravity Blackjack",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/gravityblackjack.jpg",
      redirectUrl: "/casino/aggapiconic21-gravity-blackjack",
    },
    lightspeed: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lightspeed",
      name: "Lightspeed",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/lightspeed.jpg",
      redirectUrl: "/casino/aggapiconic21-lightspeed",
    },
    literoulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lite Roulette",
      name: "Lite Roulette",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/literoulette1.jpg",
      redirectUrl: "/casino/aggapiconic21-lite-roulette",
    },
    LiveBaccarat2NC: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Live Baccarat 2 NC",
      name: "Live Baccarat 2 NC",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/LiveBaccarat2NC.jpg",
      redirectUrl: "/casino/aggapiconic21-live-baccarat-2-nc",
    },
    livebacarrat: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Live Baccarat 2",
      name: "Live Baccarat 2",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/livebacarrat.jpg",
      redirectUrl: "/casino/aggapiconic21-live-baccarat-2",
    },
    royalroulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Royal Roulette",
      name: "Royal Roulette",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/royalroulette.jpg",
      redirectUrl: "/casino/aggapiconic21-royal-roulette",
    },
    sicbo: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sic Bo",
      name: "Sic Bo",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/sicbo1.jpg",
      redirectUrl: "/casino/aggapiconic21-sic-bo",
    },
    topcard: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Top Card",
      name: "Top Card",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/topcard.jpg",
      redirectUrl: "/casino/aggapiconic21-top-card",
    },
    VirtualTopCard: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Virtual Top Card",
      name: "Virtual Top Card",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/VirtualTopCard.jpg",
      redirectUrl: "/casino/aggapiconic21-virtual-top-card",
    },
    vipblackjack: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Vip Blackjack",
      name: "Vip Blackjack",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/vipblackjack.jpg",
      redirectUrl: "/casino/aggapiconic21-vip-blackjack",
    },
  },
  turboGaming: {
    TapMines1: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "1Tap Mines",
      name: "1Tap Mines",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/1tapmines.jpg",
      redirectUrl: "/casino/aggapturbogames-1tap-mines",
    },
    aero: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Aero",
      name: "Aero",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/aero.jpg",
      redirectUrl: "/casino/aggapturbogames-aero",
    },
    bookofmines: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "BOOK OF MINES",
      name: "BOOK OF MINES",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/bookofmines.jpg",
      redirectUrl: "/casino/aggapturbogames-book-of-mines",
    },
    bubbles: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bubbles",
      name: "Bubbles",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/bubbles.jpg",
      redirectUrl: "/casino/aggapturbogames-bubbles",
    },
    catanza: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Catanza",
      name: "Catanza",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/catanza.jpg",
      redirectUrl: "/casino/aggapturbogames-catanza",
    },
    cricketboom: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Boom",
      name: "Cricket Boom",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/cricketboom.jpg",
      redirectUrl: "/casino/aggapturbogames-cricket-boom",
    },
    crystalpoker: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crystal Poker",
      name: "Crystal Poker",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/crystalpoker.jpg",
      redirectUrl: "/casino/aggapturbogames-crystal-poker",
    },
    dicethrice: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice Thrice",
      name: "Dice Thrice",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/dicethrice.jpg",
      redirectUrl: "/casino/aggapturbogames-dice-thrice",
    },
    dogsstreet: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dogs Street",
      name: "Dogs Street",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/dogsstreet.jpg",
      redirectUrl: "/casino/aggapturbogames-dogs-street-u4503",
    },
    donnyking: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "",
      name: "Donny King",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/donnyking.jpg",
      redirectUrl: "/casino/aggapturbogames-donny-king",
    },
    doubleroll: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Double Roll",
      name: "Double Roll",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/doubleroll.jpg",
      redirectUrl: "/casino/aggapturbogames-double-roll",
    },
    fastfielder: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fast Fielder",
      name: "Fast Fielder",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/fastfielder.jpg",
      redirectUrl: "/casino/aggapturbogames-fast-fielder",
    },
    fruitstowers: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fruit Towers",
      name: "Fruit Towers",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/fruitstowers.jpg",
      redirectUrl: "/casino/aggapturbogames-fruit-towers",
    },
    hilo: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hi-Lo",
      name: "Hi-Lo",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/hi-lo.jpg",
      redirectUrl: "/casino/aggapturbogames-hi-lo",
    },
    jewelclicker: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jewel Clicker",
      name: "Jewel Clicker",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/jewelclicker.jpg",
      redirectUrl: "/casino/aggapturbogames-jewel-clicker",
    },
    magickeno: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Magic Keno",
      name: "Magic Keno",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/magickeno.jpg",
      redirectUrl: "/casino/aggapturbogames-magic-keno",
    },
    multiplayermines: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Multiplayer Mines",
      name: "Multiplayer Mines",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/multiplayermines.jpg",
      redirectUrl: "/casino/aggapturbogames-multiplayer-mines",
    },
    pumpedX: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "PumpedX",
      name: "PumpedX",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/pumpedX.jpg",
      redirectUrl: "/casino/aggapturbogames-pumpedx",
    },
    spinstrike: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Spin Strike",
      name: "Spin Strike",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/spinstrike.jpg",
      redirectUrl: "/casino/aggapturbogames-spin-strike",
    },
    takemyplinko: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Take My Plinko",
      name: "Take My Plinko",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/takemyplinko.jpg",
      redirectUrl: "/casino/aggapturbogames-take-my-plinko",
    },
    tradingdice: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trading Dice",
      name: "Trading Dice",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/tradingdice.jpg",
      redirectUrl: "/casino/aggapturbogames-trading-dice",
    },
    turbomines: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Turbo Mines",
      name: "Turbo Mines",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/turbomines.jpg",
      redirectUrl: "/casino/aggapturbogames-turbo-mines",
    },
    turboplinko: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Turbo Plinko",
      name: "Turbo Plinko",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/turboplinko.jpg",
      redirectUrl: "/casino/aggapturbogames-turbo-plinko",
    },
    vortex: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VORTEX",
      name: "VORTEX",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/vortex.jpg",
      redirectUrl: "/casino/aggapturbogames-vortex",
    },
    wicketblast: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wicket Blast",
      name: "Wicket Blast",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/wicketblast.jpg",
      redirectUrl: "/casino/aggapturbogames-wicket-blast",
    },
  },
  pgsoftGaming: {
    anubiswrath: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Anubis Wrath",
      name: "Anubis Wrath",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/anubiswrath.jpg",
      redirectUrl: "/casino/aggappgsoft-anubis-wrath",
    },
    BaccaratDeluxe: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat Deluxe",
      name: "Baccarat Deluxe",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/BaccaratDeluxe.jpg",
      redirectUrl: "/casino/aggappgsoft-baccarat-deluxe",
    },
    cashmania: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cash Mania",
      name: "Cash Mania",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/cashmania.jpg",
      redirectUrl: "/casino/aggappgsoft-cash-mania",
    },
    chickyrun: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Chicky Run",
      name: "Chicky Run",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/chickyrun.jpg",
      redirectUrl: "/casino/aggappgsoft-chicky-run",
    },
    
    chocolatedeluxe: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Chocolate Deluxe",
      name: "Chocolate Deluxe",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/chocolatedeluxe.jpg",
      redirectUrl: "/casino/aggappgsoft-chocolate-deluxe",
    },
    dragonhatch2: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Hatch 2",
      name: "Dragon Hatch 2",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/dragonhatch2.jpg",
      redirectUrl: "/casino/aggappgsoft-dragon-hatch-2",
    },
    fortunedragon: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Dragon",
      name: "Fortune Dragon",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/fortunedragon.jpg",
      redirectUrl: "/casino/aggappgsoft-fortune-dragon",
    },
    fortunesnake: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Snake",
      name: "Fortune Snake",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/fortunesnake.jpg",
      redirectUrl: "/casino/aggappgsoft-fortune-snake",
    },
    futebolfever: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Futebol Fever",
      name: "Futebol Fever",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/futebolfever.jpg",
      redirectUrl: "/casino/aggappgsoft-futebol-fever",
    },
    geishasrevenge: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Geisha's Revenge",
      name: "Geisha's Revenge",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/geishasrevenge.jpg",
      redirectUrl: "/casino/aggappgsoft-geishas-revenge",
    },
    gemstonegold: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: " Gemstones Gold",
      name: "Gemstones Gold",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/gemstonegold.jpg",
      redirectUrl: "/casino/aggappgsoft-gemstones-gold",
    },
    mafiamayhem: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mafia Mayhem",
      name: "Mafia Mayhem",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/mafiamayhem.jpg",
      redirectUrl: "/casino/aggappgsoft-mafia-mayhem",
    },
    museummystery: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Museum Mystery",
      name: "Museum Mystery",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/museummystery.jpg",
      redirectUrl: "/casino/aggappgsoft-museum-mystery",
    },
    mysticpotion: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mystic Potion",
      name: "Mystic Potion",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/mysticpotion.jpg",
      redirectUrl: "/casino/aggappgsoft-mystic-potion",
    },
    oishidelights: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Oishi Delights",
      name: "Oishi Delights",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/oishidelights.jpg",
      redirectUrl: "/casino/aggappgsoft-oishi-delights",
    },
    pinatawins: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pinata Wins",
      name: "Pinata Wins",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/pinatawins1.jpg",
      redirectUrl: "/casino/aggappgsoft-pinata-wins",
    },
    riofantasia: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rio Fantasia",
      name: "Rio Fantasia",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/riofantasia.jpg",
      redirectUrl: "/casino/aggappgsoft-rio-fantasia",
    },
    sharkbounty: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "sharkbounty",
      name: "sharkbounty",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/sharkbounty.jpg",
      redirectUrl: "/casino/aggappgsoft-shark-hunter",
    },
    threecrazypiggies: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Three Crazy Piggies",
      name: "Three Crazy Piggies",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/threecrazypiggies.jpg",
      redirectUrl: "/casino/aggappgsoft-three-crazy-piggies",
    },
    tsartreasures: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tsar Treasures",
      name: "Tsar Treasures",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/tsartreasures.jpg",
      redirectUrl: "/casino/aggappgsoft-tsar-treasures",
    },
    werewolfshunt: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Werewolf's Hunt",
      name: "Werewolf's Hunt",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/werewolfshunt.jpg",
      redirectUrl: "/casino/aggappgsoft-werewolfs-hunt",
    },
    wildape3258: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Ape #3258",
      name: "Wild Ape #3258",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/wildape3258.jpg",
      redirectUrl: "/casino/aggappgsoft-wild-ape-3258",
    },
    wingsofiguazu: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wings of Iguazu",
      name: "Wings of Iguazu",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/wingsofiguazu.jpg",
      redirectUrl: "/casino/aggappgsoft-wings-of-iguazu",
    },
    yakuzahonor: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Yakuza Honor",
      name: "Yakuza Honor",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/yakuzahonor.jpg",
      redirectUrl: "/casino/aggappgsoft-yakuza-honor",
    },
    zombieoutbreak: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Zombie Outbreak",
      name: "Zombie Outbreak",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/zombieoutbreak.jpg",
      redirectUrl: "/casino/aggappgsoft-zombie-outbreak",
    },
  },
  boomingGames: {
    goldcoinsholdandwin64: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "64 Gold Coins Hold and Win",
      name: "64 Gold Coins Hold and Win",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/64goldcoinsholdandwin.jpg",
      redirectUrl: "/casino/aggapboominggames-64-gold-coins-hold-and-win",
    },
    buffaloholdandwinextreme10000: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Buffalo Hold and Win Extreme 10,000",
      name: "Buffalo Hold and Win Extreme 10,000",
      providerName: "Booming Games",
      imgUrl:
        "./images/alt-gaming/Boominggames/buffaloholdandwinextreme10000.jpg",
      redirectUrl:
        "/casino/aggapboominggames-buffalo-hold-and-win-extreme-10000",
    },
    burningclassicsroyaledition: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Burning Classics Royal Edition",
      name: "Burning Classics Royal Edition",
      providerName: "Booming Games",
      imgUrl:
        "./images/alt-gaming/Boominggames/burningclassicsroyaledition.jpg",
      redirectUrl: "/casino/aggapboominggames-burning-classics-royal-edition",
    },
    burninglove: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Burning Love",
      name: "Burning Love",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/burninglove.jpg",
      redirectUrl: "/casino/aggapboominggames-burning-love",
    },
    cashpig2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cash Pig 2",
      name: "Cash Pig 2",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/cashpig2.jpg",
      redirectUrl: "/casino/aggapboominggames-cash-pig-2",
    },
    chiefhawkspiritwalk: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cash Pig 2",
      name: "Cash Pig 2",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/chiefhawkspiritwalk.jpg",
      redirectUrl: "/casino/aggapboominggames-chief-hawks-spirit-walk",
    },
    classiccoins: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Classic Coins",
      name: "Classic Coins",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/classiccoins.jpg",
      redirectUrl: "/casino/aggapboominggames-classic-coins",
    },
    coincrusherholdandwin: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Coin Crusher Hold And Win",
      name: "Coin Crusher Hold And Win",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/coincrusherholdandwin.jpg",
      redirectUrl: "/casino/aggapboominggames-coin-crusher-hold-and-win",
    },
    diamondshits: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Diamond Hits",
      name: "Diamond Hits",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/diamondshits.jpg",
      redirectUrl: "/casino/aggapboominggames-diamond-hits",
    },
    dynamitetrio: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dynamite Trio",
      name: "Dynamite Trio",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/dynamitetrio.jpg",
      redirectUrl: "/casino/aggapboominggames-dynamite-trio",
    },
    easterclassic: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Easter Classics",
      name: "Easter Classics",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/easterclassic.jpg",
      redirectUrl: "/casino/aggapboominggames-easter-classics",
    },
    fishtalesmonsterbass: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fish Tales Monster Bass",
      name: "Fish Tales Monster Bass",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/fishtalesmonsterbass.jpg",
      redirectUrl: "/casino/aggapboominggames-fish-tales-monster-bass",
    },
    goldgoldgold5000: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gold Gold Gold 5000",
      name: "Gold Gold Gold 5000",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/goldgoldgold5000.jpg",
      redirectUrl: "/casino/aggapboominggames-gold-gold-gold-5000",
    },
    hollyjollybonananza2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Holly Jolly Bonanza 2",
      name: "Holly Jolly Bonanza 2",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/hollyjollybonananza2.jpg",
      redirectUrl: "/casino/aggapboominggames-holly-jolly-bonanza-2",
    },
    hollyjollybonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Holly Jolly Bonanza",
      name: "Holly Jolly Bonanza",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/hollyjollybonanza.jpg",
      redirectUrl: "/casino/aggapboominggames-holly-jolly-bonanza",
    },
    hollyjollycashpig: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Holly Jolly Cash Pig",
      name: "Holly Jolly Cash Pig",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/hollyjollycashpig.jpg",
      redirectUrl: "/casino/aggapboominggames-holly-jolly-cash-pig",
    },
    hotcharge: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Charge",
      name: "Hot Charge",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/hotcharge.jpg",
      redirectUrl: "/casino/aggapboominggames-hot-charge",
    },
    howlingforgold: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Howling for Gold",
      name: "Howling for Gold",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/howlingforgold.jpg",
      redirectUrl: "/casino/aggapboominggames-howling-for-gold",
    },
    jestersbellbonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jester's Bells Bonanza",
      name: "Jester's Bells Bonanza",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/jestersbellbonanza.jpg",
      redirectUrl: "/casino/aggapboominggames-jesters-bells-bonanza",
    },
    ronaldinhoscores: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ronaldinho Scores",
      name: "Ronaldinho Scores",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/ronaldinhoscores.jpg",
      redirectUrl: "/casino/aggapboominggames-ronaldinho-scores",
    },
    spacesamwalkandwin: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Space Sam Walk and Win",
      name: "Space Sam Walk and Win",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/spacesamwalkandwin.jpg",
      redirectUrl: "/casino/aggapboominggames-space-sam-walk-and-win",
    },
    spooktacularbonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Spooktacular Bonanza",
      name: "Spooktacular Bonanza",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/spooktacularbonanza.jpg",
      redirectUrl: "/casino/aggapboominggames-spooktacular-bonanza",
    },
    tastybonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tasty Bonanza",
      name: "Tasty Bonanza",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/tastybonanza.jpg",
      redirectUrl: "/casino/aggapboominggames-tasty-bonanza",
    },
    thewildwingsofphoenixdeluxe: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Wild Wings of Phoenix Deluxe",
      name: "The Wild Wings of Phoenix Deluxe",
      providerName: "Booming Games",
      imgUrl:
        "./images/alt-gaming/Boominggames/thewildwingsofphoenixdeluxe.jpg",
      redirectUrl: "/casino/aggapboominggames-the-wild-wings-of-phoenix-deluxe",
    },
    TNTbonanza2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TNT Bonanza 2",
      name: "TNT Bonanza 2",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/TNTbonanza2.jpg",
      redirectUrl: "/casino/aggapboominggames-tnt-bonanza-2",
    },
  },
  betGames: {
    poker6: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "6+ Poker",
      name: "6+ Poker",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/6+poker.jpg",
      redirectUrl: "/casino/aggapbetgames-6-poker",
    },
    badbaboons: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bad Baboons",
      name: "Bad Baboons",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/badbaboons.jpg",
      redirectUrl: "/casino/aggapbetgames-bad-baboons",
    },
    betonbaccarat: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bet On Baccarat",
      name: "Bet On Baccarat",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/betonbaccarat.jpg",
      redirectUrl: "/casino/aggapbetgames-bet-on-baccarat",
    },
    betonpoker: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bet On Poker",
      name: "Bet On Poker",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/betonpoker.jpg",
      redirectUrl: "/casino/aggapbetgames-bet-on-poker",
    },
    candycoins: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Candy Coins",
      name: "Candy Coins",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/candycoins.jpg",
      redirectUrl: "/casino/aggapbetgames-candy-coins",
    },
    citrussplash: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Citrus Splash",
      name: "Citrus Splash",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/citrussplash.jpg",
      redirectUrl: "/casino/aggapbetgames-citrus-splash",
    },
    classicroulette: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Classic Roulette",
      name: "Classic Roulette",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/classicroulette.jpg",
      redirectUrl: "/casino/aggapbetgames-classic-roulette",
    },
    classicwheel: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Classic Wheel",
      name: "Classic Wheel",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/classicwheel.jpg",
      redirectUrl: "/casino/aggapbetgames-classic-wheel",
    },
    cryptofgizasecretsuneviled: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crypt Of Giza - Secrets Unveiled",
      name: "Crypt Of Giza - Secrets Unveiled",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/cryptofgizasecretsuneviled.jpg",
      redirectUrl: "/casino/aggapbetgames-crypt-of-giza-secrets-unveiled",
    },
    cryptofgiza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crypt of Giza",
      name: "Crypt of Giza",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/cryptofgiza.jpg",
      redirectUrl: "/casino/aggapbetgames-crypt-of-giza",
    },
    diceduel: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice Duel",
      name: "Dice Duel",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/diceduel.jpg",
      redirectUrl: "/casino/aggapbetgames-dice-duel",
    },
    dragonsfate: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon's Fate",
      name: "Dragon's Fate",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/dragonsfate.jpg",
      redirectUrl: "/casino/aggapbetgames-dragons-fate",
    },
    flashroulette: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Flash Roulette",
      name: "Flash Roulette",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/flashroulette.jpg",
      redirectUrl: "/casino/aggapbetgames-flash-roulette",
    },
    footballgrid: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Football Grid",
      name: "Football Grid",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/footballgrid.jpg",
      redirectUrl: "/casino/aggapbetgames-football-grid",
    },
    instantlucky7: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Instant Lucky 7",
      name: "Instant Lucky 7",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/instantlucky7.jpg",
      redirectUrl: "/casino/aggapbetgames-instant-lucky-7",
    },
    lotuswealthwonders: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lotus Wealth Wonders",
      name: "Lotus Wealth Wonders",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/lotuswealthwonders.jpg",
      redirectUrl: "/casino/aggapbetgames-lotus-wealth-wonders",
    },
    lucky5: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 5",
      name: "Lucky 5",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/lucky5.jpg",
      redirectUrl: "/casino/aggapbetgames-lucky-5",
    },
    lucky6: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 6",
      name: "Lucky 6",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/lucky6.jpg",
      redirectUrl: "/casino/aggapbetgames-lucky-6",
    },
    lucky7: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky7",
      name: "Lucky7",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/lucky7.jpg",
      redirectUrl: "/casino/aggapbetgames-lucky-7",
    },
    penguinrush: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Penguin Rush",
      name: "Penguin Rush",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/penguinrush.jpg",
      redirectUrl: "/casino/aggapbetgames-penguin-rush",
    },
    skyward: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Skyward",
      name: "Skyward",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/skyward.jpg",
      redirectUrl: "/casino/aggapbetgames-skyward",
    },
    speedy7: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Speedy 7",
      name: "Speedy 7",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/speedy7.jpg",
      redirectUrl: "/casino/aggapbetgames-speedy-7",
    },
    starzle: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Starzle",
      name: "Starzle",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/starzle.jpg",
      redirectUrl: "/casino/aggapbetgames-starzle",
    },
    warofbets: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "War Of Bets",
      name: "War Of Bets",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/warofbets.jpg",
      redirectUrl: "/casino/aggapbetgames-war-of-bets",
    },
    wheeloffortune: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wheel Of Fortune",
      name: "Wheel Of Fortune",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/wheeloffortune.jpg",
      redirectUrl: "/casino/aggapbetgames-wheel-of-fortune",
    },
  },
  playnGoGaming: {
    mystergeniefortunes1001: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "1001 Mystery Genie Fortunes",
      name: "1001 Mystery Genie Fortunes",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/1001mystergeniefortunes.jpg",
      redirectUrl: "/casino/aggapplayngo-1001-mystery-genie-fortunes",
    },
    crystalhall: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crystal Hall",
      name: "Crystal Hall",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/crystalhall.jpg",
      redirectUrl: "/casino/aggapplayngo-crystal-hall",
    },
    gocraps: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "GO CRAPS",
      name: "GO CRAPS",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/gocraps.jpg",
      redirectUrl: "/casino/aggapplayngo-go-craps",
    },
    hotdogheist: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Dog Heist",
      name: "Hot Dog Heist",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/hotdogheist.jpg",
      redirectUrl: "/casino/aggapplayngo-hot-dog-heist",
    },
    invadingvegasrevengeonmars: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Invading Vegas Revenge on Mars",
      name: "Invading Vegas Revenge on Mars",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/invadingvegasrevengeonmars.jpg",
      redirectUrl: "/casino/aggapplayngo-invading-vegas-revenge-on-mars",
    },
    jollyrogerwildkraken: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jolly Roger Wild Kraken",
      name: "Jolly Roger Wild Kraken",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/jollyrogerwildkraken.jpg",
      redirectUrl: "/casino/aggapplayngo-jolly-roger-wild-kraken",
    },
    legacyofgemsblitzways: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Legacy of Gems Blitzways",
      name: "Legacy of Gems Blitzways",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/legacyofgemsblitzways.jpg",
      redirectUrl: "/casino/aggapplayngo-legacy-of-gems-blitzways",
    },
    legiongoldvictory: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Legion Gold Victory!",
      name: "Legion Gold Victory!",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/legiongoldvictory!.jpg",
      redirectUrl: "/casino/aggapplayngo-legion-gold-victory",
    },
    lionsageodyssey: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lion Saga Odyssey",
      name: "Lion Saga Odyssey",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/lionsageodyssey.jpg",
      redirectUrl: "/casino/aggapplayngo-lion-saga-odyssey",
    },
    lootandlabyrinths: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Loot and Labyrinths",
      name: "Loot and Labyrinths",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/lootandlabyrinths.jpg",
      redirectUrl: "/casino/aggapplayngo-loot-and-labyrinths",
    },
    loveisinthefair: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Love Is In The Fair",
      name: "Love Is In The Fair",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/loveisinthefair.jpg",
      redirectUrl: "/casino/aggapplayngo-love-is-in-the-fair",
    },
    medusasmadness: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Medusa's Madness",
      name: "Medusa's Madness",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/medusasmadness.jpg",
      redirectUrl: "/casino/aggapplayngo-medusas-madness",
    },
    midnightgold: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Midnight Gold",
      name: "Midnight Gold",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/midnightgold.jpg",
      redirectUrl: "/casino/aggapplayngo-midnight-gold",
    },
    minerdonkeyrider: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Miner Donkey Rider",
      name: "Miner Donkey Rider",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/minerdonkeyrider.jpg",
      redirectUrl: "/casino/aggapplayngo-miner-donkey-rider",
    },
    monkeybattleforthescrolls: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Monkey: Battle For The Scrolls",
      name: "Monkey: Battle For The Scrolls",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/monkeybattleforthescrolls.jpg",
      redirectUrl: "/casino/aggapplayngo-monkey-battle-for-the-scrolls",
    },
    MoonPrincessOrigins: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Moon Princess Origins",
      name: "Moon Princess Origins",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/MoonPrincessOrigins.jpg",
      redirectUrl: "/casino/aggapplayngo-moon-princess-origins",
    },
    mysteryeggsurprise: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mystery Egg Surprise",
      name: "Mystery Egg Surprise",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/mysteryeggsurprise.jpg",
      redirectUrl: "/casino/aggapplayngo-mystery-egg-surprise",
    },
    mythofdead: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Myth of Dead",
      name: "Myth of Dead",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/mythofdead.jpg",
      redirectUrl: "/casino/aggapplayngo-myth-of-dead",
    },
    potionofmadness: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Potion of Madness",
      name: "Potion of Madness",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/potionofmadness.jpg",
      redirectUrl: "/casino/aggapplayngo-potion-of-madness",
    },
    richwildeandthetomeofdead: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rich Wilde and the Tome of Dead",
      name: "Rich Wilde and the Tome of Dead",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/richwildeandthetomeofdead.jpg",
      redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-tome-of-dead",
    },
    sobeksgodlyspins: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sobek's Godly Spins",
      name: "Sobek's Godly Spins",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/sobeksgodlyspins.jpg",
      redirectUrl: "/casino/aggapplayngo-sobeks-godly-spins",
    },
    spinninRecordintothebeat: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Spinnin' Records Into the Beat",
      name: "Spinnin' Records Into the Beat",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/spinninRecordintothebeat.jpg",
      redirectUrl: "/casino/aggapplayngo-spinnin-records-into-the-beat",
    },
    towerquestlegacy: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tower Quest Legacy",
      name: "Tower Quest Legacy",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/towerquestlegacy.jpg",
      redirectUrl: "/casino/aggapplayngo-tower-quest-legacy",
    },
    treasureofkongar: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Treasures of Kongar",
      name: "Treasures of Kongar",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/treasureofkongar.jpg",
      redirectUrl: "/casino/aggapplayngo-treasures-of-kongar",
    },
    trinityimpact: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trinity Impact",
      name: "Trinity Impact",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/trinityimpact.jpg",
      redirectUrl: "/casino/aggapplayngo-trinity-impact",
    },
  },
  playtechliveGaming: {
    allbetsblackjackbrasileira: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "All Bets Blackjack Brasileira",
      name: "All Bets Blackjack Brasileira",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/allbetsblackjackbrasileira.jpg",
      redirectUrl: "/casino/aggapplaytechlive-all-bets-blackjack-brasileira",
    },
    autoroulette2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Auto Roulette 2",
      name: "Auto Roulette 2",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/autoroulette2.jpg",
      redirectUrl: "/casino/aggapplaytechlive-auto-roulette-2",
    },
    baccaratbrasileiranocommission: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat Brasileira No Comission",
      name: "Baccarat Brasileira No Comission",
      providerName: "Playtech Live",
      imgUrl:
        "./images/alt-gaming/playtechlive/baccaratbrasileiranocommission.jpg",
      redirectUrl: "/casino/aggapplaytechlive-baccarat-brasileira-no-comission",
    },
    baccaratbrasileira: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat Brasileira",
      name: "Baccarat Brasileira",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/baccaratbrasileira.jpg",
      redirectUrl: "/casino/aggapplaytechlive-baccarat-brasileira",
    },
    baccaratnocommission: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat No Commission",
      name: "Baccarat No Commission",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/baccaratnocommission.jpg",
      redirectUrl: "/casino/aggapplaytechlive-baccarat-no-comission",
    },
    blackjack2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 2",
      name: "Blackjack 2",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/blackjack2.jpg",
      redirectUrl: "/casino/aggapplaytechlive-blackjack-2",
    },
    blackjack10: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 10",
      name: "Blackjack 10",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/blackjack10.jpg",
      redirectUrl: "/casino/aggapplaytechlive-blackjack-10",
    },
    blackjacksoiree4: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack SoirÃ©e 4",
      name: "Blackjack SoirÃ©e 4",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/blackjacksoiree4.jpg",
      redirectUrl: "/casino/aggapplaytechlive-blackjack-soirace-4",
    },
    cashcollectroulettelive: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cash Collect Roulette Live",
      name: "Cash Collect Roulette Live",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/cashcollectroulettelive.jpg",
      redirectUrl: "/casino/aggapplaytechlive-cash-collect-roulette-live",
    },
    deutschesspeedroulette: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Deutsches Speed Roulette",
      name: "Deutsches Speed Roulette",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/deutschesspeedroulette.jpg",
      redirectUrl: "/casino/aggapplaytechlive-deutsches-speed-roulette",
    },
    grandroyalecashback: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Grand Royale Cashback",
      name: "Grand Royale Cashback",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/grandroyalecashback.jpg",
      redirectUrl: "/casino/aggapplaytechlive-grand-royale-cashback",
    },
    japanesesqueezebaccaratnocommisison: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Japanese Squeeze Baccarat No Comission",
      name: "Japanese Squeeze Baccarat No Comission",
      providerName: "Playtech Live",
      imgUrl:
        "./images/alt-gaming/playtechlive/japanesesqueezebaccaratnocommisison.jpg",
      redirectUrl:
        "/casino/aggapplaytechlive-japanese-squeeze-baccarat-no-comission",
    },
    japanesesqueezebaccarat: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Japanese Squeeze Baccarat",
      name: "Japanese Squeeze Baccarat",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/japanesesqueezebaccarat.jpg",
      redirectUrl: "/casino/aggapplaytechlive-japanese-squeeze-baccarat",
    },
    koreanspeedbaccarat1nocommission: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Korean Speed Baccarat 1 No Comission",
      name: "Korean Speed Baccarat 1 No Comission",
      providerName: "Playtech Live",
      imgUrl:
        "./images/alt-gaming/playtechlive/koreanspeedbaccarat1nocommission.jpg",
      redirectUrl:
        "/casino/aggapplaytechlive-korean-speed-baccarat-1-no-comission",
    },
    koreanspeedbaccarat1: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Korean Speed Baccarat 1",
      name: "Korean Speed Baccarat 1",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/koreanspeedbaccarat1.jpg",
      redirectUrl: "/casino/aggapplaytechlive-korean-speed-baccarat-1",
    },
    luckyballroulette: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Ball Roulette",
      name: "Lucky Ball Roulette",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/luckyballroulette.jpg",
      redirectUrl: "/casino/aggapplaytechlive-lucky-ball-roulette",
    },
    megafireblazeblackjacklive: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mega Fire Blaze Blackjack Live",
      name: "Mega Fire Blaze Blackjack Live",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/megafireblazeblackjacklive.jpg",
      redirectUrl: "/casino/aggapplaytechlive-mega-fire-blaze-blackjack-live",
    },
    megafireblazeluckyballbrasileiro: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mega Fire Blaze Lucky Ball Brasileiro",
      name: "Mega Fire Blaze Lucky Ball Brasileiro",
      providerName: "Playtech Live",
      imgUrl:
        "./images/alt-gaming/playtechlive/megafireblazeluckyballbrasileiro.jpg",
      redirectUrl:
        "/casino/aggapplaytechlive-mega-fire-blaze-lucky-ball-brasileiro",
    },
    puntobancosoireegold: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Punto Banco Soirée Gold",
      name: "Punto Banco Soirée Gold",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/puntobancosoireegold.jpg",
      redirectUrl: "/casino/aggapplaytechlive-punto-banco-soiree-gold",
    },
    royaleblackjack2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Royale Blackjack 2",
      name: "Royale Blackjack 2",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/royaleblackjack2.jpg",
      redirectUrl: "/casino/aggapplaytechlive-royale-blackjack-2",
    },
    RuYispeedbaccaratnocommission: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ru Yi Speed Baccarat No Comission",
      name: "Ru Yi Speed Baccarat No Comission",
      providerName: "Playtech Live",
      imgUrl:
        "./images/alt-gaming/playtechlive/RuYispeedbaccaratnocommission.jpg",
      redirectUrl:
        "/casino/aggapplaytechlive-ru-yi-speed-baccarat-no-comission",
    },
    RuYispeedbaccarat: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ru Yi Speed Baccarat",
      name: "Ru Yi Speed Baccarat",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/RuYispeedbaccarat.jpg",
      redirectUrl: "/casino/aggapplaytechlive-ru-yi-speed-baccarat",
    },
    speedsicbo: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Speed SicBo",
      name: "Speed SicBo",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/speedsicbo.jpg",
      redirectUrl: "/casino/aggapplaytechlive-speed-sicbo",
    },
    stickybanditsroulettelive: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sticky Bandits Roulette Live",
      name: "Sticky Bandits Roulette Live",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/stickybanditsroulettelive.jpg",
      redirectUrl: "/casino/aggapplaytechlive-sticky-bandits-roulette-live",
    },
    thegreatestcardshow: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Greatest Cards Show",
      name: "The Greatest Cards Show",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/thegreatestcardshow.jpg",
      redirectUrl: "/casino/aggapplaytechlive-the-greatest-cards-show",
    },
  },

  smartsoftGaming: {
    bonusesbonanza4: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "4 Bonuses Bonanza",
      name: "4 Bonuses Bonanza",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/4bonusesbonanza.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-4-bonuses-bonanza",
    },
    baoslot5x: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bao Slot 5X",
      name: "Bao Slot 5X",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/baoslot5x.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-bao-slot-5x",
    },
    bookofbonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Book of Bonanza",
      name: "Book of Bonanza",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/bookofbonanza.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-book-of-bonanza",
    },
    bookoffuturia: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Book of Futuria",
      name: "Book of Futuria",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/bookoffuturia.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-book-of-futuria",
    },
    crashduelX: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Duel X",
      name: "Crash Duel X",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/crashduelX.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-crash-duel-x",
    },
    cricketerX: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricketer X",
      name: "Cricketer X",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/cricketerX.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-cricketer-x",
    },
    foxyhot20: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Foxy Hot 20",
      name: "Foxy Hot 20",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/foxyhot20.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-foxy-hot-20",
    },
    geniesbonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Genie's Bonanza",
      name: "Genie's Bonanza",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/geniesbonanza.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-genies-bonanza",
    },
    hotsamba: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Samba",
      name: "Hot Samba",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/hotsamba.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-hot-samba",
    },
    hunterX: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hunter X",
      name: "Hunter X",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/hunterX.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-hunter-x",
    },
    madslot: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mad Slot",
      name: "Mad Slot",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/madslot.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-mad-slot",
    },
    mineisland: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mad Slot",
      name: "Mad Slot",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/mineisland.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-mad-slot",
    },
    multihotways: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Multi Hot Ways",
      name: "Multi Hot Ways",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/multihotways.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-multi-hot-ways",
    },
    rollX: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Roll X",
      name: "Roll X",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/rollX.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-roll-x",
    },
    safarisimba: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Safari Simba",
      name: "Safari Simba",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/safarisimba.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-safari-simba",
    },
    sambadadeusa: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Samba Da Deusa",
      name: "Samba Da Deusa",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/sambadadeusa.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-samba-da-deusa",
    },
    slicerX: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "SlicerX",
      name: "SlicerX",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/slicerX.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-slicerx",
    },
    sugarfiesta: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sugar Fiesta",
      name: "Sugar Fiesta",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/sugarfiesta.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-sugar-fiesta",
    },
    towerx: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TowerX",
      name: "TowerX",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/towerx.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-towerx",
    },
    wildjungle: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Jungle",
      name: "Wild Jungle",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/wildjungle.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-wild-jungle",
    },
    wildmultistars: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Multi Stars",
      name: "Wild Multi Stars",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/wildmultistars.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-wild-multi-stars",
    },
  },
};
